export default __webpack_public_path__ + "static/media/Niba Jabeen Akber.c66a3460.jpg";